export enum ZeroQueryProduct {
	CONFLUENCE = 'CONFLUENCE',
	JIRA = 'JIRA',
	GOOGLE = 'GOOGLE',
	SLACK = 'SLACK',
	SHAREPOINT = 'SHAREPOINT',
}

export enum ZeroQueryDateRange {
	TODAY = 'today',
	YESTERDAY = 'yesterday',
	PAST_7_DAYS = 'past7days',
	PAST_30_DAYS = 'past30days',
}

export enum ZeroQueryType {
	COLLABORATOR_PROFILE = 'COLLABORATOR_PROFILE',
	CONFLUENCE_PAGES_CREATED = 'CONFLUENCE_PAGES_CREATED',
	CONFLUENCE_PAGES_CREATED_30_DAYS = 'CONFLUENCE_PAGES_CREATED_30_DAYS',
	CONFLUENCE_PAGES_CREATED_7_DAYS = 'CONFLUENCE_PAGES_CREATED_7_DAYS',
	CONFLUENCE_PAGES_CREATED_COLLABORATOR = 'CONFLUENCE_PAGES_CREATED_COLLABORATOR',
	CONFLUENCE_PAGES_CREATED_COLLABORATOR_30_DAYS = 'CONFLUENCE_PAGES_CREATED_COLLABORATOR_30_DAYS',
	CONFLUENCE_PAGES_CREATED_COLLABORATOR_7_DAYS = 'CONFLUENCE_PAGES_CREATED_COLLABORATOR_7_DAYS',
	JIRA_NLQ = 'JIRA_NLQ',
	JIRA_NLQ_COLLABORATOR = 'JIRA_NLQ_COLLABORATOR',
	JIRA_TICKETS_ASSIGNED = 'JIRA_TICKETS_ASSIGNED',
	JIRA_TICKETS_CREATED = 'JIRA_TICKETS_CREATED',
	JIRA_TICKETS_CREATED_COLLABORATOR = 'JIRA_TICKETS_CREATED_COLLABORATOR',
	RECENT_WORK = 'RECENT_WORK',
	RELATED_QUESTION = 'RELATED_QUESTION',
	THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS = 'THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS',
	THIRD_PARTY_GOOGLE_MY_DOCS = 'THIRD_PARTY_GOOGLE_MY_DOCS',
	THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS = 'THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS',
	THIRD_PARTY_SHAREPOINT_MY_DOCS = 'THIRD_PARTY_SHAREPOINT_MY_DOCS',
	THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES = 'THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES',
	THIRD_PARTY_SLACK_MY_MESSAGES = 'THIRD_PARTY_SLACK_MY_MESSAGES',
	WHO_IS = 'WHO_IS',
}

export type ZeroQuery = {
	query: string;
	type: ZeroQueryType;
	product?: ZeroQueryProduct;
	accountId?: string | null;
	avatarUrl?: string | null;
	dateRange?: ZeroQueryDateRange | null;
};

export interface QuickFindZeroQueriesQueryType {
	knowledgeDiscovery?: {
		zeroQueries: {
			zeroQueries: ZeroQuery[];
		};
	};
}

export interface QuickFindZeroQueriesQueryVariables {
	cloudId: string;
	product?: Uppercase<string>;
}

export interface MutateZeroQueriesMutationVariables {
	input: {
		cloudId: string;
		query: string;
		product?: Uppercase<string>;
	};
}

export interface MutateZeroQueriesMutationType {
	knowledgeDiscovery: {
		markZeroQueryInteracted: {
			success: boolean;
			errors: {
				message: string;
				extensions: {
					errorType: string;
					statusCode: number;
				};
			}[];
		};
	};
}
